import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-fr',
  templateUrl: './fr.component.html',
  styleUrl: './fr.component.scss'
})
export class PrivacyPolicyFrComponent {

}
